import * as _ from "lodash";
import http from "../constant/api";

export const StaffStatsService = {
  reportStaffOnline: async (filter) => {
    const result = await http.get(`/api/staff-stats/report`, {
      params: filter,
    });

    return result;
  },
};
